// @noflow
import { motion } from 'framer-motion';
import getGreetingTime from 'utils/greeting';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import { transparentize } from 'color2k';

const MotionDiv = motion.div;

const AuthPage = ({ title, children, ...props }) => {
  return (
    <div
      css={`
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(
            to top,
            ${transparentize(Colors.gray1, 0.6)},
            ${transparentize(Colors.gray1, 0.6)}
          ),
        background-size: cover;
        background-position: center;
      `}
      {...props}
    >
      <MotionDiv
        key="login"
        css={`
          display: flex;
          flex-direction: column;
          justify-content: center;
        `}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Text
          variant="h1"
          align="center"
          css={`
            margin-bottom: 25px;
            text-shadow: 0 2px 4px ${transparentize(Colors.gray1, 0.6)};
          `}
        >
          Good {getGreetingTime()}.
        </Text>
        <div
          css={`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: stretch;
            background-color: ${Colors.gray3};
            width: 320px;
            border-radius: 6px;
            overflow: hidden;
            margin: 0 auto;
          `}
        >
          <div
            css={`
              background-color: ${Colors.gray4};
              width: 100%;
              padding: 15px 40px;
            `}
          >
            <Text variant="display4">{title}</Text>
          </div>
          <div
            css={`
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding: 25px;
            `}
          >
            {children}
          </div>
        </div>
      </MotionDiv>
    </div>
  );
};

export default AuthPage;
